import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpService: HttpService) { }
  fetchEmployees(payload: any) {
    return this.httpService.getList('api/User/GetUsers', payload);
  }
  submitEmployee(payload: any) {
    if (payload?.id) {
      return this.httpService.put('api/User/' + payload?.id, payload);
    } else {
      return this.httpService.post('api/User', payload);
    }
  }
  deleteEmployee(employee_id: string) {
    return this.httpService.delete('api/User/' + employee_id);
  }
  getUserInfoDetails(payload: any) {
    const id = payload?.id ?? "";
    const masterId = payload?.masterExpenseId ? `/${payload.masterExpenseId}` : "";

    return this.httpService.get(`api/User/GetUserInfoDetails/${id}${masterId}`);
  }
  downloadUserManual() {
    return this.httpService.get('api/User/DownloadUserManual');
  }  
  updateEmployeeStatus(employee_id:string) {
    return this.httpService.put(`api/User/UserActiveInActiveToggle/${employee_id}`,{});
  }
}
